import apiClient from './client';

export interface AuditLogEntry {
  id: string;
  userId: string | null;
  userEmail: string | null;
  action: string;
  target: string | null;
  details: string | null;
  ipAddress: string | null;
  createdAt: string;
}

export interface AuditLogResponse {
  logs: AuditLogEntry[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface ProtokollFilter {
  action?: string;
  userId?: string;
  /** Teil einer E-Mail-Adresse, Groß-/Kleinschreibung egal. */
  email?: string;
  /** Tagesdatum als YYYY-MM-DD. */
  from?: string;
  to?: string;
}

/** Leere Felder weglassen – sonst filtert der Server auf den leeren String. */
function bereinige(f: ProtokollFilter): Record<string, string> {
  const raus: Record<string, string> = {};
  for (const [k, v] of Object.entries(f)) {
    if (typeof v === 'string' && v.trim() !== '') raus[k] = v.trim();
  }
  return raus;
}

export async function getAuditLogs(
  params?: ProtokollFilter & { page?: number; limit?: number },
): Promise<AuditLogResponse> {
  const { page, limit, ...filter } = params ?? {};
  const { data } = await apiClient.get<AuditLogResponse>('/audit-log', {
    params: { ...bereinige(filter), ...(page ? { page } : {}), ...(limit ? { limit } : {}) },
  });
  return data;
}

// ─── CSV-Export ──────────────────────────────────────────────────────────────
//
// Über den apiClient statt per <a href>: die Konsole hängt an einer anderen
// Domain als die API, und ein einfacher Link nähme weder Anmeldung noch die
// eingestellte Basis-Adresse mit. Der Server streamt, hier wird der Strom erst
// am Ende zu einer Datei – bei sehr großen Protokollen dauert das entsprechend.

export async function exportAuditLogs(filter: ProtokollFilter): Promise<void> {
  const res = await apiClient.get('/audit-log/export', {
    params: bereinige(filter),
    responseType: 'blob',
  });

  const url = URL.createObjectURL(res.data as Blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `protokoll-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
